import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import RTSPPlayer from '@blade-sxp/monitor/components/rtsp-sense/index.vue';
import * as _ from 'lodash';
let default_1 = class default_1 extends Vue {
    url;
    currIndex;
    ObjectType = {
        OBJECT_UNKNOWN: 0,
        OBJECT_FACE: 1,
        OBJECT_PEDESTRIAN: 2,
        OBJECT_AUTOMOBILE: 3,
        OBJECT_CYCLIST: 4,
        OBJECT_HUMAN_POWERED_VEHICLE: 5,
        OBJECT_CROWD: 6,
        OBJECT_SCENARIO: 7,
        OBJECT_ALGO: 8,
    };
    isPlay = true;
    videoWsHost = this.mapUrl();
    videoUrl = 'rtsp://engine-video-ingress-service-worker:8554/QWVTYUPKJHL--T0Uu_Zjfl5aWPz2LI569yHYtqlYktb6VO-_5NOhSnuYoyk7Fck1U2At1ev8g8eE5O4UrtkRLKvaY7yU5W48t8k5t4GXmGpSES7j3MDvsJk8=';
    autoPlay = true;
    renderType = 'frame';
    showAttrsInfo = true;
    drawRect = true;
    rectColors = {
        [this.ObjectType.OBJECT_FACE]: '#00E0FE',
        [this.ObjectType.OBJECT_PEDESTRIAN]: '#8DCA3F',
        [this.ObjectType.OBJECT_AUTOMOBILE]: '#F1B206',
        [this.ObjectType.OBJECT_CYCLIST]: '#F1B206',
        [this.ObjectType.OBJECT_HUMAN_POWERED_VEHICLE]: '#E5644E',
    };
    isShow = false;
    mapUrl() {
        const res = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_RTSP_WS : `wss://${window.location.host}/${process.env.VUE_APP_RTSP_WS}`;
        return res || '';
    }
    mounted() { }
    handleStop() {
        this.$refs.player.stop();
    }
    handlePlay() {
        this.$refs.player.play();
    }
    handleResize(ele) {
        if (this.$refs.player) {
            _.throttle(() => this.$refs.player.changeVideoSize(), 1000);
        }
    }
    get isCurrShow() {
        return this.url;
    }
    onindexChange(newVal) {
        this.$refs.player?.refreshVideoPlayer();
    }
};
__decorate([
    Prop()
], default_1.prototype, "url", void 0);
__decorate([
    Prop()
], default_1.prototype, "currIndex", void 0);
__decorate([
    Watch('url', { immediate: true })
], default_1.prototype, "onindexChange", null);
default_1 = __decorate([
    Component({
        name: 'RealTime',
        components: { 'rtsp-player': RTSPPlayer },
        i18n: {
            messages: {
                'en-us': {
                    monitor: 'No video',
                },
                zh: {
                    monitor: '无监控',
                },
            },
        },
    })
], default_1);
export default default_1;
